$(document).ready(function () {
	$(window).on("load", function () {
		function openModal() {
			document.body.classList.add("modal--open");
		}

		function setRegion(region) {
			localStorage.setItem("region", region);
		}

		function getRegion() {
			return localStorage.getItem("region");
		}

		function closeModal() {
			document.body.classList.remove("modal--open");
		}

		var region = getRegion();

		if (!region || region == "UK") {
			const params = new URLSearchParams(window.location.search);
			region = params.get("region");
			if (region == "USA") {
				setRegion("USA");
			}
		}

		if (!region || region == "CA") {
			const params = new URLSearchParams(window.location.search);
			region = params.get("region");
			if (region == "USA") {
				setRegion("USA");
			}
		}

		if (region !== "USA") {
			// If region isn't set, open modal
			openModal();
		}

		var modal = document.getElementById("regionModal");

		// UK button
		$(buttonUk).click(function () {
			setRegion("UK");
			closeModal();
		});

		// USA button
		$(buttonUsa).click(function () {
			setRegion("USA");
			closeModal();
		});

		// USA button
		$(buttonCa).click(function () {
			setRegion("CA");
			closeModal();
		});
	});

	// IE10
	if (navigator.userAgent.match(/MSIE\s([\d.]+)/)) {
		$("body").addClass("ie10");
	}

	// IE11
	if (navigator.userAgent.match(/Trident.*rv:11\./)) {
		$("body").addClass("ie11");
	}

	// IE11 & IE10 hacks because the guy that built this theme needs to be shot!
	if ($("body").hasClass("ie10") || $("body").hasClass("ie11")) {
		// Remove image loading class for IE10/IE11
		$(".product-image-gallery").removeClass("loading");

		// Cart doesn't display on hover IE11/IE10
		$("a.icon-cart-header").hover(function () {
			$(this).next("div.cart-wrapper").css("display", "block");
		});

		function remove_cart() {
			$("div.cart-wrapper").css("display", "none");
		}
		window.addEventListener("scroll", remove_cart);
	}

$(function () {
  // Only target the ACTUAL checkout control(s), not every submit in /cart
  const CHECKOUT_SELECTOR = "input[type='submit'][name='checkout'], button[type='submit'][name='checkout']";
  const CHECKBOX_SELECTOR = "#terms-conditions";
  const ERROR_WRAPPER_SELECTOR = "div.compliance-checkboxes";

  // Explicitly exclude your cart update button(s)
  const UPDATE_SELECTOR = ".btn-update, button[name='update'], input[name='update']";

  const MSG =
    "Unfortunately we cannot process your order unless you provide your consent to the use of your personal data for fraud screening. You also need to confirm you have read and agree to our terms & conditions.";

  // Track what actually triggered the submit (checkout vs update cart)
  let lastSubmitWasCheckout = false;

  function consentGiven() {
    const $cb = $(CHECKBOX_SELECTOR);
    return $cb.is(":checked") || (($cb.val() || "").toLowerCase() === "yes");
  }

  function setErrorState(on) {
    $(ERROR_WRAPPER_SELECTOR).toggleClass("error", !!on);
  }

  function showConsentError() {
    setErrorState(true);
    alert(MSG);
  }

  function ensureWrapper($btn) {
    if ($btn.parent().data("consentWrap")) return $btn.parent();

    const $wrap = $("<span/>")
      .attr("data-consent-wrap", "1")
      .data("consentWrap", true)
      .css({ position: "relative", display: "inline-block" });

    $btn.wrap($wrap);
    return $btn.parent();
  }

  function addOverlay($btn) {
    const $wrap = ensureWrapper($btn);

    if ($wrap.find("[data-consent-overlay='1']").length) return;

    const $overlay = $("<span/>")
      .attr("data-consent-overlay", "1")
      .css({
        position: "absolute",
        inset: 0,
        zIndex: 9999,
        cursor: "pointer",
        background: "transparent",
      })
      .on("click", function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showConsentError();
        return false;
      });

    $wrap.append($overlay);
  }

  function removeOverlay($btn) {
    const $wrap = $btn.parent("[data-consent-wrap='1']");
    if (!$wrap.length) return;
    $wrap.find("[data-consent-overlay='1']").remove();
  }

  function updateCheckoutState() {
    const allowed = consentGiven();

    $(CHECKOUT_SELECTOR).not(UPDATE_SELECTOR).each(function () {
      const $btn = $(this);

      // Disable interaction only for checkout buttons
      this.style.pointerEvents = allowed ? "auto" : "none";

      if (allowed) {
        removeOverlay($btn);
        setErrorState(false);
      } else {
        addOverlay($btn);
      }
    });
  }

  // Capture intent: checkout click vs update-cart click
  $(document).on("click", CHECKOUT_SELECTOR, function () {
    lastSubmitWasCheckout = true;
  });

  $(document).on("click", UPDATE_SELECTOR, function () {
    lastSubmitWasCheckout = false;
    // Also clear any error UI when they just update the cart
    setErrorState(false);
  });

  // Initial
  updateCheckoutState();

  // Checkbox changes
  $(document).on("change click", CHECKBOX_SELECTOR, function () {
    updateCheckoutState();
  });

  // Only block the /cart submit when the submitter was CHECKOUT
  $(document).on("submit", "form[action='/cart']", function (e) {
    const submitter = e.originalEvent && e.originalEvent.submitter ? e.originalEvent.submitter : null;

    const isCheckoutSubmitter =
      (submitter && $(submitter).is(CHECKOUT_SELECTOR)) || lastSubmitWasCheckout;

    // Reset for next submit so Update Cart doesn't get caught by a stale flag
    lastSubmitWasCheckout = false;

    if (isCheckoutSubmitter && !consentGiven()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showConsentError();
      return false;
    }
  });
});


	// Popup announcement...
	$("#pop-up.announcement img.close-btn").click(function () {
		$(".mask").fadeOut(800);
		$(this).parent().fadeOut(800);
		sessionStorage.setItem("showcountrydialog", "false");
	});

	// Function to check users location...
	function check_user_location() {
		// Check if the browser supports session storage...
		if (typeof Storage !== "undefined") {
			// Check if 'showcountrydialog' has been set and equal to true...
			var showcountrydialog = sessionStorage.getItem("showcountrydialog");

			// If 'showcountrydialog' is equal to null or true output the dialog box...
			if (showcountrydialog == null || showcountrydialog == "true") {
				$.ajax({
					url: "https://ipapi.co/json/",
					type: "GET",
					dataType: "json",
					success: function (data) {
						if (data.error !== true && data.country !== "GB") {
							$(".mask").fadeIn(800);
							$("#pop-up.announcement").fadeIn(800);
						}
					},
				});
			}
		}
	}

	// Run on page load...
	check_user_location();

	// var links = document.links;
	// for (let i = 0, linksLength = links.length; i < linksLength; i++) {
	// 	if (links[i].hostname !== window.location.hostname && !links[i].href.includes("leefiltersdirect.com")) {
	// 		links[i].target = "_blank";
	// 		links[i].rel = "noreferrer noopener";
	// 	}
	// }

	// $(".country-toggle a[href]").each(function () {
	// 	fetch($(this).attr("href"))
	// 		.then((response) => {
	// 			if (response.status === 404) {
    //                 // Get the URL of the response
    //                 const responseUrl = new URL(response.url);
    //                 // Get the home URL
    //                 const homeUrl = responseUrl.origin;
                  
	// 				//homepageLink = "https://usa.leefiltersdirect.com/";
	// 				$(this).attr("href", homeUrl);
	// 			}
	// 		})
	// 		.catch((error) => {});
	// });
});